import React from 'react';
import { Constrain, Expandable } from '@moda/om';
import { HelpCenter, AboutModa, HowToShop } from './SiteFooterLinks';
import './SiteFooterMobile.scss';
import { SiteFooterMailingList } from './SiteFooterMailingList';

export const SiteFooterMobile: React.FC = () => {
  return (
    <Constrain className="SiteFooterMobile">
      <Expandable className="SiteFooterMobile__more" name="MORE INFORMATION">
        <div className="SiteFooterMobile__more-links">
          <HelpCenter />
          <AboutModa />
          <HowToShop />
        </div>
      </Expandable>

      <a
        className="SiteFooterMobile__download"
        href="https://itunes.apple.com/us/app/moda-operandi/id781702094"
      >
        Download the Moda App
      </a>

      <div className="SiteFooterMobile__sign-up">
        <SiteFooterMailingList />
      </div>

      <div className="SiteFooterMobile__basement">
        © {new Date().getFullYear()} Moda Operandi, Inc. All Rights Reserved.
      </div>
    </Constrain>
  );
};
